import { render, staticRenderFns } from "./PersonnalInfo.vue?vue&type=template&id=37dc02e6&scoped=true"
import script from "./PersonnalInfo.vue?vue&type=script&lang=js"
export * from "./PersonnalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonnalInfo.vue?vue&type=style&index=0&id=37dc02e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc02e6",
  null
  
)

export default component.exports